import { XGrid } from "@material-ui/x-grid";
import { withStyles } from "@material-ui/core/styles";

export const styles = (theme) => {
  const isDark = theme.palette.type === "dark";
  const borderColor = theme.palette.divider;
  const headerBg = isDark ? theme.palette.action.hover : theme.palette.grey[50];
  const textColor = theme.palette.text.primary;
  const hoverShadow = isDark
    ? "0 4px 8px rgba(0,0,0,0.3)"
    : "0 4px 8px rgba(0,0,0,0.1)";

  return {
    root: {
      "& .MuiDataGrid-columnsContainer": {
        borderTop: `1px solid ${borderColor}`,
        borderBottom: `1px solid ${borderColor}`,
        backgroundColor: headerBg,
        fontSize: theme.typography.caption.fontSize,
      },
      "& .MuiDataGrid-iconSeparator": {
        opacity: 0,
      },
      "& .MuiDataGrid-colCell": {
        borderRight: `1px solid ${borderColor}`,
        padding: theme.spacing(0, 1),
      },
      "& .MuiDataGrid-row": {
        transition: "transform 0.15s ease, box-shadow 0.15s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: hoverShadow,
          zIndex: 1,
          position: "relative",
        },
      },
    },
    columnHeader: {
      borderRight: `1px solid ${borderColor}`,
      padding: theme.spacing(0, 1),
      fontSize: theme.typography.caption.fontSize,
    },
    cell: {
      borderRight: `1px solid ${borderColor}`,
      padding: theme.spacing(0, 1),
      fontSize: theme.typography.caption.fontSize,
      borderBottom: `1px solid ${borderColor}`,
      color: textColor,
    },
  };
};

export const withXGridStyles = withStyles(styles);

const StyledXGrid = withXGridStyles(XGrid);

export default StyledXGrid;
